function parseCookies (value, isJSON) {
	const cookie = document.cookie.split('; ').find(row => row.startsWith(value));
	if (!cookie) {
		return null;
	}
	let c = cookie.split('=')[1];
	if (isJSON === true) {
		c = JSON.parse(c);
	}
	return c;
}

export { parseCookies };
